import { ref, computed, watchEffect, toValue } from 'vue';
import { __, __x } from 'JIX/gettext.js';

export function useTimeOfDay({ updateInterval = 60 * 1000 } = {}) {
    const hour = ref();
    const update = () => hour.value = (new Date()).getHours();
    update();

    if (updateInterval) {
        let intervalId;
        watchEffect((onCleanup) => {
            setInterval(update, updateInterval);
            onCleanup(() => { if (intervalId) { clearInterval(intervalId); } });
        });
    }

    return computed(() => {
        if (hour.value >= 6 && hour.value < 10) {
            return 'morning';
        } else if (hour.value >= 10 && hour.value < 13) {
            return 'day';
        } else if (hour.value >= 13 && hour.value < 18) {
            return 'afternoon';
        } else if (hour.value >= 18 && hour.value < 23) {
            return 'evening';
        } else {
            return 'night';
        }
    });
}

export function useTimeOfDayGreeting(name) {
    const timeOfDay = useTimeOfDay();
    return computed(() => {
        const nameVal = toValue(name);
        if (nameVal) {
            if (timeOfDay.value === 'morning') {
                return __x('Godmorgen {name}!', { name: nameVal });
            } else if (timeOfDay.value === 'evening') {
                return __x('Godaften {name}!', { name: nameVal });
            } else {
                return __x('Hej {name}!', { name: nameVal });
            }
        } else {
            if (timeOfDay.value === 'morning') {
                return __('Godmorgen!');
            } else if (timeOfDay.value === 'evening') {
                return __('Godaften!');
            } else {
                return __('Velkommen!');
            }
        }
    });
}